import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";

import Select from "../../../../components/Select";

export default function RemoteWork({ searchObject, onChange, t }) {
  const [remoteWorkOptions, setRemoteWorkOptions] = useState([]);

  useEffect(
    () =>
      CommonService.getRemoteWorkOptions().then((data) =>
        setRemoteWorkOptions(data)
      ),
    []
  );

  return (
    <div>
      <legend className="fontsize-legend">{t("Remote Work")}</legend>
      <Select
        className="form-select fontsize-legend"
        value={searchObject.remoteWorkId || ""}
        name="remoteWorkId"
        onChange={onChange}
      >
        <option value=""></option>
        {remoteWorkOptions &&
          remoteWorkOptions.map((remote) => (
            <option
              className="fontsize-legend"
              key={remote.id}
              value={remote.id}
            >
              {t(remote.description)}
            </option>
          ))}
      </Select>
    </div>
  );
}
